/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiResponseRewardImageUpload } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface GlobalRewardsImageServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param file 
     */
    globalRewardsImageControllerUpload0(file: Blob, extraHttpRequestParams?: any): Observable<ApiResponseRewardImageUpload>;

    /**
     * 
     * 
     * @param file 
     */
    globalRewardsImageControllerUpload1(file: Blob, extraHttpRequestParams?: any): Observable<ApiResponseRewardImageUpload>;

}
